class BoostNotificationHandler {
  constructor() {
    this.notificationElement = null;
    this.boostContainer = null;
    this.observer = null;
    this.isClosedThisSession = false;
    this.init();
  }

  init() {
    this.notificationElement = document.querySelector('.move-to-boost');

    if (!this.notificationElement) {
      return;
    }

    if (this.isClosedThisSession) {
      this.hideNotification();

      return;
    }

    this.hideNotification();
    this.setupCloseButton();
    this.checkForBoostLayout();
    this.setupObserver();
  }

  hideNotification() {
    if (this.notificationElement) {
      this.notificationElement.style.display = 'none';
    }
  }

  showNotification() {
    if (this.notificationElement) {
      this.notificationElement.style.display = '';
    }
  }

  setupCloseButton() {
    const closeButton = this.notificationElement.querySelector('.close-box');

    if (closeButton) {
      closeButton.addEventListener('click', () => {
        this.closeNotification();
      });
    }
  }

  closeNotification() {
    this.hideNotification();
    this.isClosedThisSession = true;
  }

  checkForBoostLayout() {
    const boostLayout = document.querySelector('.boost-sd-layout');

    if (boostLayout) {
      this.moveNotificationAfterToolbar();
    }
  }

  moveNotificationAfterToolbar() {
    if (this.isClosedThisSession) {
      return;
    }

    const toolbarContainer = document.querySelector('.boost-sd__toolbar-container');

    if (toolbarContainer && this.notificationElement) {
      toolbarContainer.insertAdjacentElement('afterend', this.notificationElement);
      this.showNotification();
    }
  }

  setupObserver() {
    if (!window.MutationObserver) {
      return;
    }

    this.observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              if (node.classList && node.classList.contains('boost-sd-layout')) {
                this.moveNotificationAfterToolbar();
              } else if (node.querySelector && node.querySelector('.boost-sd-layout')) {
                this.moveNotificationAfterToolbar();
              }

              if (node.classList && node.classList.contains('move-to-boost')) {
                if (this.isNotificationClosed()) {
                  node.style.display = 'none';
                }
              } else if (node.querySelector && node.querySelector('.move-to-boost')) {
                const notificationElements = node.querySelectorAll('.move-to-boost');

                notificationElements.forEach(notificationEl => {
                  if (this.isNotificationClosed()) {
                    notificationEl.style.display = 'none';
                  }
                });
              }
            }
          });
        }
      });
    });

    this.observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  destroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new BoostNotificationHandler();
});

window.addEventListener('beforeunload', () => {
  if (window.boostNotificationHandler) {
    window.boostNotificationHandler.destroy();
  }
});
